// extracted by mini-css-extract-plugin
export default {"Main":"Body_Main__1746d"};